module.exports = __webpack_public_path__ + "img/wide.e7d0cfd2.jpg";